import assign from "../assign/index.js";
export default function cloneObject(object) {
  return assign({}, object);
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/cloneObject/index.js
// module id = ./node_modules/date-fns/esm/_lib/cloneObject/index.js
// module chunks = 1